"use strict";

var _interopRequireDefault = require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.set");
require("core-js/modules/es6.string.iterator");
var _regeneratorRuntime2 = _interopRequireDefault(require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.array.find-index");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.array.find");
var _objectSpread2 = _interopRequireDefault(require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _upload = require("../../api/upload.js");
var _app = require("../../api/app.js");
var _inkhubMonthly = require("../../api/inkhubMonthly.js");
var _apprepair = require("../../api/apprepair.js");
var _awsSdk = _interopRequireDefault(require("aws-sdk"));
var _aliOss = _interopRequireDefault(require("ali-oss"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function createBlock() {
  return {
    id: null,
    language: "",
    theme: "",
    bannerUrl: "",
    bannerPreview: "",
    articleUrl: "",
    articleFileName: "上传",
    articleLoading: false
  };
}
var blockFieldRules = {
  bannerUrl: [{
    required: true,
    message: "请上传banner",
    trigger: "change"
  }],
  articleUrl: [{
    required: true,
    message: "请上传文章",
    trigger: "change"
  }]
};
var _default = exports.default = {
  name: "EditInkhubMonthly",
  data: function data() {
    return {
      formLabelWidth: "120px",
      isDisable: false,
      pageLoading: false,
      type: [],
      bannerDialogVisible: false,
      dialogBannerUrl: "",
      editPeriod: "",
      blocks: [],
      privateKey_1: "XAkWgD0A",
      privateKey_2: "KSVDWG",
      keyId: "K66NRBmhuzqh6QX36ICAKIAVT4",
      secretId: "zlMc+UDjkbfloun7DrYRHfJQNupFNQfZuKHd49NL8jqu2x"
    };
  },
  computed: {
    blockRules: function blockRules() {
      var vm = this;
      return (0, _objectSpread2.default)({
        language: [{
          required: true,
          message: "请选择语言",
          trigger: "change"
        }, {
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback();
              return;
            }
            var duplicateCount = vm.blocks.filter(function (block) {
              return block.language === value;
            }).length;
            if (duplicateCount > 1) {
              callback(new Error("语言不能重复"));
            } else {
              callback();
            }
          },
          trigger: "change"
        }],
        theme: [{
          required: true,
          message: "请填写网页标题",
          trigger: "blur"
        }, {
          validator: function validator(rule, value, callback) {
            if (!value || !String(value).trim()) {
              callback(new Error("请填写网页标题"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }]
      }, blockFieldRules);
    }
  },
  mounted: function mounted() {
    var _this = this;
    var period = this.$route.query && this.$route.query.period;
    if (period == null || period === "") {
      this.msgTip("error", "缺少期数");
      return;
    }
    this.editPeriod = String(period);
    (0, _apprepair.getLanList)({
      name: "lan"
    }).then(function (res) {
      _this.type = res.dictionaryVOList || [];
      _this.loadByPeriod(_this.editPeriod);
    }).catch(function () {
      _this.msgTip("error", "加载语言列表失败");
    });
  },
  methods: {
    // 与新增页一致：选项 value 为 valueCn；接口若回编码则映射回展示值
    normalizeLanguage: function normalizeLanguage(lang) {
      if (!lang) {
        return "";
      }
      var item = this.type.find(function (row) {
        return row.value === lang || row.valueCn === lang;
      });
      return item ? item.valueCn : lang;
    },
    loadByPeriod: function loadByPeriod(period) {
      var _this2 = this;
      this.pageLoading = true;
      (0, _inkhubMonthly.getInkhubMonthlyByPeriod)(period).then(function (res) {
        _this2.pageLoading = false;
        if (!res || res.success === false) {
          _this2.msgTip("error", res && res.errorMsg || "加载该期数据失败");
          return;
        }
        // CommonListVO → voList
        var list = res.voList || [];
        if (!list.length) {
          _this2.msgTip("error", "该期暂无数据");
          return;
        }
        _this2.blocks = list.map(function (item) {
          return {
            id: item.id,
            language: _this2.normalizeLanguage(item.language),
            theme: item.theme || "",
            bannerUrl: item.bannerUrl || "",
            bannerPreview: item.bannerUrl ? _this2.splitDownloadUrl(item.bannerUrl) : "",
            articleUrl: item.articleUrl || "",
            articleFileName: item.articleUrl ? "重新上传" : "上传",
            articleLoading: false
          };
        });
      }).catch(function () {
        _this2.pageLoading = false;
        _this2.msgTip("error", "加载该期数据失败");
      });
    },
    previewBanner: function previewBanner(url) {
      this.dialogBannerUrl = url;
      this.bannerDialogVisible = true;
    },
    downloadArticle: function downloadArticle(url) {
      var _this3 = this;
      if (!url) {
        return;
      }
      var rawName = decodeURIComponent(url.split("?")[0].split("/").pop() || "article.html");
      var fileName = /\.html?$/i.test(rawName) ? rawName : rawName + ".html";

      // 在点击手势内先弹出另存为，避免 fetch 后再 a.click 被浏览器拦截
      if (typeof window.showSaveFilePicker === "function") {
        window.showSaveFilePicker({
          suggestedName: fileName,
          types: [{
            description: "HTML",
            accept: {
              "text/html": [".html", ".htm"]
            }
          }]
        }).then(function (handle) {
          return fetch(url).then(function (res) {
            if (!res.ok) {
              throw new Error("fail");
            }
            return res.arrayBuffer();
          }).then(function (buf) {
            return handle.createWritable().then(function (writable) {
              return writable.write(buf).then(function () {
                return writable.close();
              });
            });
          });
        }).catch(function (err) {
          if (err && err.name === "AbortError") {
            return;
          }
          _this3.msgTip("error", "文章下载失败");
        });
        return;
      }

      // 不支持另存为 API 时：同步打开空白页再触发下载，避免弹窗/下载拦截
      var popup = window.open("about:blank");
      if (!popup) {
        this.msgTip("warning", "请允许浏览器弹窗后重试下载");
        return;
      }
      fetch(url).then(function (res) {
        if (!res.ok) {
          throw new Error("fail");
        }
        return res.arrayBuffer();
      }).then(function (buf) {
        var blobUrl = URL.createObjectURL(new Blob([buf], {
          type: "text/html"
        }));
        var a = popup.document.createElement("a");
        a.href = blobUrl;
        a.download = fileName;
        popup.document.body.appendChild(a);
        a.click();
        setTimeout(function () {
          URL.revokeObjectURL(blobUrl);
          popup.close();
        }, 500);
      }).catch(function () {
        popup.close();
        _this3.msgTip("error", "文章下载失败");
      });
    },
    addBlock: function addBlock() {
      this.blocks.push(createBlock());
    },
    canRemoveBlock: function canRemoveBlock(block) {
      // 已有语言不可删；本次新加的板块可删
      if (block.id != null && block.id !== "") {
        return false;
      }
      return this.blocks.length > 1;
    },
    removeBlock: function removeBlock(index) {
      var _this4 = this;
      var block = this.blocks[index];
      if (!this.canRemoveBlock(block)) {
        return;
      }
      this.blocks.splice(index, 1);
      this.$nextTick(function () {
        _this4.blocks.forEach(function (_, i) {
          _this4.validateBlockField(i, "language");
        });
      });
    },
    isLanguageUsed: function isLanguageUsed(valueCn, currentIndex) {
      return this.blocks.some(function (block, index) {
        return index !== currentIndex && block.language === valueCn;
      });
    },
    onLanguageChange: function onLanguageChange(index) {
      var _this5 = this;
      var value = this.blocks[index].language;
      if (!value) {
        return;
      }
      var duplicateIndex = this.blocks.findIndex(function (block, i) {
        return i !== index && block.language === value;
      });
      if (duplicateIndex !== -1) {
        this.blocks[index].language = "";
        this.msgTip("error", "\u8BED\u8A00\u300C".concat(value, "\u300D\u5DF2\u5728\u677F\u5757 ").concat(duplicateIndex + 1, " \u4E2D\u4F7F\u7528\uFF0C\u4E0D\u80FD\u91CD\u590D"));
      }
      this.$nextTick(function () {
        _this5.blocks.forEach(function (_, i) {
          _this5.validateBlockField(i, "language");
        });
      });
    },
    beforeUploadBanner: function beforeUploadBanner(file, index) {
      var _this6 = this;
      if (!file.type || file.type.indexOf("image/") !== 0) {
        this.msgTip("warning", "请上传图片文件");
        return false;
      }
      var fd = new FormData();
      fd.append("file", file);
      var req = new XMLHttpRequest();
      req.open("GET", document.location, false);
      req.send(null);
      var userType = req.getResponseHeader("Domain") ? req.getResponseHeader("Domain") : "";
      var handleSuccess = function handleSuccess(res) {
        if (res.success) {
          _this6.blocks[index].bannerPreview = _this6.splitDownloadUrl(res.voT.downloadUrl);
          _this6.blocks[index].bannerUrl = res.voT.downloadUrl;
          _this6.validateBlockField(index, "bannerUrl");
        } else {
          _this6.msgTip("error", res.errorMsg);
        }
      };
      if (userType == "cn") {
        (0, _upload.ufileUpload)(fd).then(function (res) {
          handleSuccess(res);
        }).catch(function () {
          _this6.msgTip("error", "banner上传失败");
        });
      } else {
        (0, _upload.awsUpload)(fd).then(function (res) {
          handleSuccess(res);
        }).catch(function () {
          _this6.msgTip("error", "banner上传失败");
        });
      }
      return false;
    },
    submitArticleUpload: function submitArticleUpload(index) {
      var _this7 = this;
      var ref = this.$refs["articleUpload" + index];
      var input = Array.isArray(ref) ? ref[0] : ref;
      var fileData = input && input.files ? input.files[0] : null;
      if (!fileData) {
        return;
      }
      if (!/\.html?$/i.test(fileData.name) && fileData.type !== "text/html" && fileData.type !== "application/xhtml+xml") {
        this.msgTip("warning", "请上传 html 文件");
        input.value = null;
        return;
      }
      this.blocks[index].articleLoading = true;
      this.isDisable = true;

      // 与 applicationStore APK 上传一致
      var req = new XMLHttpRequest();
      req.open("GET", document.location, false);
      req.send(null);
      var userType = req.getResponseHeader("Domain") ? req.getResponseHeader("Domain") : "";
      (0, _app.appAapply)({
        fileName: fileData.name,
        folder: "1"
      }).then(function (res) {
        if (!res.success) {
          _this7.blocks[index].articleLoading = false;
          _this7.isDisable = false;
          _this7.msgTip("error", res.errorMsg || "申请上传失败");
          input.value = null;
          return;
        }
        var fileNames = res.s3Url.substr(res.s3Url.lastIndexOf("/", res.s3Url.lastIndexOf("/") - 1) + 1);
        // Domain 判断取链接：cn → ufile域名+路径，com → s3Url
        var downloadUrl = userType == "cn" ? String(res.ufileUrl || "").replace(/\/$/, "") + "/" + fileNames : res.s3Url;
        if (!downloadUrl || downloadUrl === "/" + fileNames) {
          _this7.blocks[index].articleLoading = false;
          _this7.isDisable = false;
          _this7.msgTip("error", userType == "cn" ? "未返回 ufileUrl" : "未返回 s3Url");
          input.value = null;
          return;
        }
        if (userType == "cn") {
          var _accessKeyId = _this7.decryption(res.accessKeyId);
          var accessKeySecret = _this7.decryption(res.accessKeySecret);
          var bucket = res.bucketName;
          var clientOssAli = new _aliOss.default({
            accessKeyId: _accessKeyId,
            accessKeySecret: accessKeySecret,
            bucket: bucket,
            endpoint: "supernote.com.cn"
          });
          _this7.startUpload(fileData, clientOssAli, fileNames, downloadUrl, index, input);
        } else {
          var decryptedPart1 = _this7.keyId.slice(-7);
          var decryptedPart2 = _this7.keyId.slice(-14, -7).split("").reverse().join("");
          var decryptedPart3 = _this7.keyId.slice(0, -14).slice(0, -6).split("").reverse().join("");
          var accessKeyId = decryptedPart1 + decryptedPart2 + decryptedPart3;
          var secretdecryptedPart1 = _this7.secretId.slice(-15);
          var secretdecryptedPart2 = _this7.secretId.slice(-31, -15).split("").reverse().join("");
          var secretreversedPart3 = _this7.secretId.slice(0, -31).slice(0, -6).split("").reverse().join("");
          var secretAccessKey = secretdecryptedPart1 + secretdecryptedPart2 + secretreversedPart3;
          var s3 = new _awsSdk.default.S3({
            accessKeyId: accessKeyId,
            secretAccessKey: secretAccessKey,
            region: "ap-northeast-1"
          });
          var _bucket = res.bucketName;
          // 与 APK 一致显式设 ContentType，html 用 text/html
          var contentType = "text/html";
          var params = {
            Bucket: _bucket,
            Key: fileNames,
            ContentType: contentType,
            ACL: "public-read"
          };
          s3.getSignedUrl("putObject", params, function (error, url) {
            if (error) {
              console.error("获取预签名URL失败：", error);
              _this7.blocks[index].articleLoading = false;
              _this7.isDisable = false;
              _this7.msgTip("error", "文章上传失败");
              input.value = null;
              return;
            }
            var xhr = new XMLHttpRequest();
            xhr.open("PUT", url, true);
            xhr.setRequestHeader("Content-Type", contentType);
            xhr.onreadystatechange = function () {
              if (xhr.readyState === XMLHttpRequest.DONE) {
                _this7.blocks[index].articleLoading = false;
                _this7.isDisable = false;
                if (xhr.status === 200) {
                  _this7.blocks[index].articleUrl = downloadUrl;
                  _this7.validateBlockField(index, "articleUrl");
                  input.value = null;
                } else {
                  _this7.msgTip("error", "文章上传失败");
                  input.value = null;
                }
              }
            };
            xhr.send(fileData);
          });
        }
      }).catch(function () {
        _this7.blocks[index].articleLoading = false;
        _this7.isDisable = false;
        _this7.msgTip("error", "文章上传失败");
        input.value = null;
      });
    },
    // 阿里云 OSS 上传（与 applicationStore.startUpload 一致）
    startUpload: function () {
      var _startUpload = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(fileData, clientOssAli, innerName1, downloadUrl, index, input) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return clientOssAli.multipartUpload("/" + innerName1, fileData, {
                headers: {
                  "Content-Type": "text/html"
                }
              });
            case 3:
              this.blocks[index].articleLoading = false;
              this.isDisable = false;
              this.blocks[index].articleUrl = downloadUrl;
              this.validateBlockField(index, "articleUrl");
              input.value = null;
              _context.next = 17;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              console.error("UploadError:", _context.t0);
              this.blocks[index].articleLoading = false;
              this.isDisable = false;
              this.msgTip("error", "文章上传失败");
              input.value = null;
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 10]]);
      }));
      function startUpload(_x, _x2, _x3, _x4, _x5, _x6) {
        return _startUpload.apply(this, arguments);
      }
      return startUpload;
    }(),
    decryption: function decryption(encryptionStr) {
      if (encryptionStr === null || encryptionStr === "") {
        return encryptionStr;
      }
      var decryptedStr = "";
      var length = Math.ceil(encryptionStr.length / 2);
      for (var i = 0; i < length; i++) {
        var charCode = parseInt(encryptionStr.substring(i * 2, i * 2 + 2), 16) - 1;
        decryptedStr += String.fromCharCode(charCode);
      }
      var startIndex = this.privateKey_1.length;
      var endIndex = decryptedStr.length - this.privateKey_2.length;
      endIndex = Math.max(endIndex, 0);
      return decryptedStr.substring(startIndex, endIndex);
    },
    validateBlockField: function validateBlockField(index, field) {
      var _this8 = this;
      this.$nextTick(function () {
        var ref = _this8.$refs["blockForm" + index];
        var form = Array.isArray(ref) ? ref[0] : ref;
        if (form) {
          form.validateField(field);
        }
      });
    },
    validateBlockForms: function validateBlockForms() {
      var _this9 = this;
      var tasks = this.blocks.map(function (block, index) {
        return new Promise(function (resolve) {
          var ref = _this9.$refs["blockForm" + index];
          var form = Array.isArray(ref) ? ref[0] : ref;
          if (!form) {
            resolve(false);
            return;
          }
          form.validate(function (valid) {
            return resolve(valid);
          });
        });
      });
      return Promise.all(tasks).then(function (results) {
        return results.every(Boolean);
      });
    },
    submit: function submit() {
      var _this10 = this;
      this.validateBlockForms().then(function (blocksValid) {
        if (!blocksValid) {
          _this10.msgTip("warning", "请完整填写各板块信息");
          return;
        }
        var languageSet = new Set(_this10.blocks.map(function (item) {
          return item.language;
        }));
        if (languageSet.size !== _this10.blocks.length) {
          _this10.msgTip("error", "各板块语言不能重复");
          return;
        }
        _this10.doSubmit();
      });
    },
    doSubmit: function doSubmit() {
      var _this11 = this;
      this.isDisable = true;
      if (!this.editPeriod) {
        this.isDisable = false;
        this.msgTip("error", "期数不能为空");
        return;
      }
      // 后台：period 必填；languages 同新增，Item 可带 id
      var languages = this.blocks.map(function (block) {
        var item = {
          language: block.language,
          theme: block.theme.trim(),
          bannerUrl: block.bannerUrl,
          articleUrl: block.articleUrl
        };
        // 已有语言带真实 id；新加板块 id 传 0
        item.id = block.id != null && block.id !== "" ? block.id : 0;
        return item;
      });
      (0, _inkhubMonthly.updateInkhubMonthly)({
        period: this.editPeriod,
        theme: this.blocks[0].theme.trim(),
        languages: languages
      }).then(function (res) {
        _this11.isDisable = false;
        if (res.success) {
          _this11.msgTip("success", "保存成功");
          _this11.$store.dispatch("tagsView/delView", _this11.$route).then(function () {
            _this11.$nextTick(function () {
              _this11.$router.replace({
                path: "/other/inkhubMonthly",
                query: {
                  cur: _this11.$route.query.cur
                }
              });
            });
          });
        } else {
          _this11.msgTip("error", res.errorMsg);
        }
      }).catch(function () {
        _this11.isDisable = false;
        _this11.msgTip("error", "保存失败");
      });
    },
    splitDownloadUrl: function splitDownloadUrl(url) {
      if (!url) {
        return "";
      }
      return url + (url.indexOf("?") > -1 ? "&" : "?") + "t=" + new Date().getTime();
    },
    msgTip: function msgTip(msgType, msgInfo) {
      this.$message({
        type: msgType,
        message: msgInfo,
        center: true
      });
    }
  }
};